<template>
  <!-- begin login -->
  <div :class="th === 'old' ? 'login bg-black animated fadeInDown' : 'login-new animated fadeInDown'">
      <!-- begin brand -->
      <div class="login-header">
          <div class="brand" v-if="th === 'old'">
              <img :src="logo" style="width: 45px"/> NFJuara Admin
          </div>
          <div class="brand" v-if="th === 'new'" style="margin: 40px 0px 40px 0px;">
              <img :src="'https://www.nfjuara.id/wp-content/uploads/2021/08/logo-nf.png'" style="width: 150px"/> Admin
          </div>
          
          <div class="icon" v-if="th === 'old'">
              <i class="fa fa-sign-in"></i>
          </div>
      </div>
      <!-- end brand -->
      <div class="login-content">
          <app-alert v-if="this.hasError" v-bind:message="errorMessage" isError="true" v-on:closed="hasError = false"></app-alert>
          <form class="margin-bottom-0" @keyup.enter="handleLogin()">
              <div class="form-group m-b-20">
                  <input type="text" v-model="email" :class="th === 'new' ? 'form-control input-lg m-t-20 brd-new' : 'form-control input-lg inverse-mode no-border'" placeholder="Email Address" required />
              </div>
              <div class="form-group m-b-20">
                  <input v-if="th ==='old'" type="password" v-model="password" :class="th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border'" placeholder="Password" required />
                  <div class="input-group" v-if="th ==='new'">
                    <input :type="typpss" v-model="password" :class="th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border'" placeholder="Password" required>
                    <div class="input-group-addon hint-ic" @click="typpss = 'text'" v-if="typpss == 'password'"><i class="fa fa-eye"></i></div>
                    <div class="input-group-addon hint-ic" @click="typpss = 'password'" v-if="typpss == 'text'"><i class="fa fa-eye-slash"></i></div>
                  </div>
              </div>
              <div class="checkbox m-b-20" v-if="th === 'old'">
                  <label>
                      <input type="checkbox" /> Remember Me
                  </label>
              </div>
              <div class="login-buttons">
                  <button type="button" class="btn btn-success btn-block btn-lg" @click="handleLogin()">Sign me in</button>
              </div>
          </form>
      </div>
  </div>
  <!-- end login -->
</template>
<style>

.hint-ic {
  cursor: pointer;
}
.login-new {
  background: white;
    position: absolute;
    max-width: 480px;
    width: 100%;
    height: 340px;
    margin: 0 auto;
    top: 20%;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid #10AA85;
    border-radius: 15px;
    padding: 15px;
    text-align: center;
}

.brd-new {
  border:1px solid #10AA85 !important;
}
.input-group-addon {
  background-color: #10AA85 !important;
  color: white;
}
</style>
<script>
import Alert from '@/components/layout/Alert'
import auth from '@/services/auth.js'
import logo from '@/assets/img/launcher.png'

export default {
  name: 'Login',
  components: {
    'app-alert': Alert
  },
  data: function () {
    return {
      typpss: 'password',
      th: sessionStorage.getItem('theme') ? sessionStorage.getItem('theme') : 'old',
      logo: logo,
      errors: [],
      email: '',
      password: '',
      hasError: false,
      errorMessage: '',
      errorTitle: ''    }
  },
  methods: {
    validateForm: function () {
      this.errors = []
      if (!this.password) this.errors.push('password')
      if (!this.email) this.errors.push('email')

      if (this.errors.length == 0) return true

      this.hasError = true
      this.errorMessage = this.errors.join(' dan ') + ' harus diisi'

      return false
    },
    handleLogin: function () {
      if (this.validateForm()) {
        var context = this
        auth.doLogin(context.email, context.password, function (result) {
          var userData = result.data
          if (result.success) {
            auth.doValidateToken(userData.token, function (validateTokenResult) {
              var appScopes = validateTokenResult.scopes
              context.$ls.set('logged_in', true)
              context.$ls.set('token', userData.token)
              context.$ls.set('refresh_token', userData.refreshToken)
              context.$ls.set('profiles', {
                name: userData.name,
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                phone: userData.phoneNumber,
                picture: userData.picture
              })

              context.$store.commit('auth_authenticated', appScopes)
              if(context.th === 'new') location.reload()
            })
          } else {
            context.hasError = true
            context.errorMessage = result.message
          }
        })
      }
    }
  },
  mounted: function () {
    if (this.$store.state.auth.loggedIn) {
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?2e73fddf